"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarketplaceIdToCxTuple = void 0;
const config_name_1 = require("./config-name");
const config_type_1 = require("./config-type");
const data_type_1 = require("../data/data-type");
/**
 * Defines the Configurations available under the MarketplaceID to CXID
 * mapping table.
 */
class MarketplaceIdToCxTuple extends config_name_1.ConfigName {
    constructor(_name, _returnType) {
        super(_name, _returnType);
    }
    getConfigType() {
        return config_type_1.ConfigType.MARKETPLACEID_TO_CX_TUPLE;
    }
}
exports.MarketplaceIdToCxTuple = MarketplaceIdToCxTuple;
/**
 * cx-id is stored in String format.
 */
MarketplaceIdToCxTuple.CX_ID = new MarketplaceIdToCxTuple('cx_id', data_type_1.DataType.STRING);
/**
 * cx-family is stored in String format.
 */
MarketplaceIdToCxTuple.CX_FAMILY = new MarketplaceIdToCxTuple('cx_family', data_type_1.DataType.STRING);
//# sourceMappingURL=marketplaceId-to-cx-tuple.js.map